module.exports = __webpack_public_path__ + "assets/img/yujing.b0eb89d4.png";